"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ClaytonLogo = _interopRequireDefault(require("pubweb-smokey/dist/components/ClaytonLogo/ClaytonLogo"));

var _Chevron = require("pubweb-smokey/dist/components/Icon/Chevron");

var _Social = require("pubweb-smokey/dist/components/Icon/Social");

var _analytics = require("pubweb-smokey/dist/utils/analytics");

var _DXAccountContext = require("../../../contexts/DXAccountContext");

var _SectionLink = _interopRequireDefault(require("../SectionLink/SectionLink"));

var _Footer = require("./Footer.styled");

var _config = require("../../../utils/config");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Footer = function Footer(_ref) {
  var _accountContext$state, _accountContext$state2, _accountContext$state3, _accountContext$state4;

  var _ref$internalLink = _ref.internalLink,
      internalLink = _ref$internalLink === void 0 ? true : _ref$internalLink,
      _ref$addSiteUrl = _ref.addSiteUrl,
      addSiteUrl = _ref$addSiteUrl === void 0 ? false : _ref$addSiteUrl,
      _ref$siteUrlOverride = _ref.siteUrlOverride,
      siteUrlOverride = _ref$siteUrlOverride === void 0 ? '' : _ref$siteUrlOverride,
      _ref$showTwitter = _ref.showTwitter,
      showTwitter = _ref$showTwitter === void 0 ? false : _ref$showTwitter,
      _ref$ssr = _ref.ssr,
      ssr = _ref$ssr === void 0 ? false : _ref$ssr;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      shopMenuOpenMobile = _useState2[0],
      setShopMenuOpenMobile = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      discoverMenuOpenMobile = _useState4[0],
      setDiscoverMenuOpenMobile = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      connectMenuOpenMobile = _useState6[0],
      setConnectMenuOpenMobile = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      accountMenuOpenMobile = _useState8[0],
      setAccountMenuOpenMobile = _useState8[1];

  var accountContext = (0, _react.useContext)(_DXAccountContext.DXAccountContext);
  return /*#__PURE__*/_react.default.createElement(_Footer.FooterStyles, null, /*#__PURE__*/_react.default.createElement("footer", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "shop"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "h5 footer-heading",
    onClick: function onClick() {
      return setShopMenuOpenMobile(!shopMenuOpenMobile);
    }
  }, "Shop", /*#__PURE__*/_react.default.createElement("div", {
    className: shopMenuOpenMobile ? 'up' : 'down'
  }, /*#__PURE__*/_react.default.createElement(_Chevron.ChevronDwn, null))), /*#__PURE__*/_react.default.createElement("ul", {
    className: shopMenuOpenMobile ? 'menu-visible-mobile' : 'menu-hidden-mobile'
  }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/find-a-home/",
    className: "caption",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "Homes")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/locations/",
    className: "caption",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "Locations")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/get-inspired/",
    className: "caption",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "Inspiration")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "discover"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "h5 footer-heading",
    onClick: function onClick() {
      return setDiscoverMenuOpenMobile(!discoverMenuOpenMobile);
    }
  }, "Discover", /*#__PURE__*/_react.default.createElement("div", {
    className: discoverMenuOpenMobile ? 'up' : 'down'
  }, /*#__PURE__*/_react.default.createElement(_Chevron.ChevronDwn, null))), /*#__PURE__*/_react.default.createElement("ul", {
    className: discoverMenuOpenMobile ? 'menu-visible-mobile' : 'menu-hidden-mobile'
  }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/studio/",
    className: "caption",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "Studio")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/about/",
    className: "caption",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "About")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/sustainability/",
    className: "caption",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "Sustainability")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/social-responsibility/",
    className: "caption",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "Social Responsibility")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/dream-to-reality/",
    className: "caption",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "Dream to Reality")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/pages/prefabulous/",
    className: "caption",
    internalLink: false,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "Prefabulous \xAE")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/about/conflict-minerals/",
    className: "caption",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "Conflict Minerals")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "connect"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "h5 footer-heading",
    onClick: function onClick() {
      return setConnectMenuOpenMobile(!connectMenuOpenMobile);
    }
  }, "Connect", /*#__PURE__*/_react.default.createElement("div", {
    className: connectMenuOpenMobile ? 'up' : 'down'
  }, /*#__PURE__*/_react.default.createElement(_Chevron.ChevronDwn, null))), /*#__PURE__*/_react.default.createElement("ul", {
    className: connectMenuOpenMobile ? 'menu-visible-mobile' : 'menu-hidden-mobile'
  }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/contact-us/",
    className: "caption",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "Contact Us")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/newsroom/",
    className: "caption newsroom",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    onClick: function onClick() {
      (0, _analytics.pushGTMEvent)('newsroom');
    },
    ssr: ssr
  }, "Newsroom")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/builder-resources/",
    className: "caption builder-resources",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    onClick: function onClick() {
      (0, _analytics.pushGTMEvent)('builder-resources');
    },
    ssr: ssr
  }, "Builder Resources")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: (0, _config.getCareerSiteUrl)(),
    className: "caption careers-link",
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: function onClick() {
      (0, _analytics.pushGTMEvent)('careers-link');
    }
  }, "Careers")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/subsidiaries/",
    className: "caption",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "Subsidiaries")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/faq/",
    className: "caption",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "FAQs")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "account"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "h5 footer-heading",
    onClick: function onClick() {
      return setAccountMenuOpenMobile(!accountMenuOpenMobile);
    }
  }, "My Account", /*#__PURE__*/_react.default.createElement("div", {
    className: accountMenuOpenMobile ? 'up' : 'down'
  }, /*#__PURE__*/_react.default.createElement(_Chevron.ChevronDwn, null))), /*#__PURE__*/_react.default.createElement("ul", {
    className: accountMenuOpenMobile ? 'menu-visible-mobile' : 'menu-hidden-mobile'
  }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: (_accountContext$state = accountContext.state) !== null && _accountContext$state !== void 0 && _accountContext$state.account ? '/portal/' : '/myhome-planner',
    className: "caption portalLink",
    internalLink: (_accountContext$state2 = accountContext.state) !== null && _accountContext$state2 !== void 0 && _accountContext$state2.account ? false : true,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "MyHome Account")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: (_accountContext$state3 = accountContext.state) !== null && _accountContext$state3 !== void 0 && _accountContext$state3.account ? '/portal/favorites/' : '/myhome-planner',
    className: "caption portalLink",
    internalLink: (_accountContext$state4 = accountContext.state) !== null && _accountContext$state4 !== void 0 && _accountContext$state4.account ? false : true,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr,
    onClick: function onClick() {
      return accountContext.actions.setPostLoginRedirectPath('/portal/favorites/');
    }
  }, "My Favorites")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://p.widencdn.net/9vm128/Homeowner-Manual/",
    className: "caption homeowner-resources",
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: function onClick() {
      (0, _analytics.pushGTMEvent)('homeowner-manual');
    }
  }, "Homeowner Manual")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.claytonhomecare.com/",
    className: "caption home-care-guide-link",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Home Care Guide")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "logo-social"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "clayton-logo"
  }, /*#__PURE__*/_react.default.createElement(_ClaytonLogo.default, {
    letterColor: "#fff",
    rooftopColor: "#fff"
  })), /*#__PURE__*/_react.default.createElement("ul", {
    className: "social-icons"
  }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.facebook.com/ClaytonHomes",
    className: "caption facebook-icon",
    onClick: function onClick() {
      (0, _analytics.pushGTMEvent)('facebook-icon');
    },
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "img",
    "aria-label": "Facebook"
  }, /*#__PURE__*/_react.default.createElement(_Social.Facebook, null)))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.instagram.com/clayton/",
    className: "caption instagram-icon",
    onClick: function onClick() {
      (0, _analytics.pushGTMEvent)('instagram-icon');
    },
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "img",
    "aria-label": "Instagram"
  }, /*#__PURE__*/_react.default.createElement(_Social.Instagram, null)))), showTwitter && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://twitter.com/ClaytonHomes",
    className: "caption",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "img",
    "aria-label": "Twitter"
  }, /*#__PURE__*/_react.default.createElement(_Social.Twitter, null)))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.pinterest.com/claytonhomes/",
    className: "caption pinterest-icon",
    onClick: function onClick() {
      (0, _analytics.pushGTMEvent)('pinterest-icon');
    },
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "img",
    "aria-label": "Pinterest"
  }, /*#__PURE__*/_react.default.createElement(_Social.Pinterest, null)))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.youtube.com/user/claytonhomes",
    className: "caption youtube-icon",
    onClick: function onClick() {
      (0, _analytics.pushGTMEvent)('youtube-icon');
    },
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "img",
    "aria-label": "YouTube"
  }, /*#__PURE__*/_react.default.createElement(_Social.YouTube, null)))), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://www.tiktok.com/@claytonhomes",
    className: "caption tiktok-icon",
    onClick: function onClick() {
      (0, _analytics.pushGTMEvent)('tiktok-icon');
    },
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    role: "img",
    "aria-label": "TikTok"
  }, /*#__PURE__*/_react.default.createElement(_Social.TikTok, null))))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "legal-privacy"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "legal-privacy-inside"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "xsmall"
  }, "\xA9 1998-", new Date().getFullYear(), " Clayton."), /*#__PURE__*/_react.default.createElement("p", {
    className: "legal-privacy-links xsmall"
  }, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/legal/",
    target: "_blank",
    className: "xsmall",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "Legal"), /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    to: "/privacy/",
    target: "_blank",
    className: "xsmall",
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    ssr: ssr
  }, "Privacy"), /*#__PURE__*/_react.default.createElement("a", {
    className: "xsmall",
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
    }
  }, "Do Not Sell or Share My Personal Information")))));
};

var _default = Footer;
exports.default = _default;